import {MitgliederDomainDto} from '@wba/models/dto/mitglieder-domain-dto';
import {WeitereAenderungenDto} from '@wba/modules/weitere-aenderungen/models/weitere-aenderungen-dto';
import {Observable} from 'rxjs';


export abstract class WeitereAenderungenService {
  abstract getMitglieder(): Observable<MitgliederDomainDto>;

  abstract save(mitglieder): Observable<any>;

  abstract getWeitereAenderungen(): Observable<WeitereAenderungenDto[]>;

  abstract saveWeitereAenderungen(weitereAenderungenListe: WeitereAenderungenDto[]): Observable<Object>;

  abstract deleteWeitereAenderungen(weitereAenderungenIdListe: string[]): Observable<any>;
}
